import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { StagingMandateStateService } from 'src/app/core/mandates-api/staging-mandate-state.service';

@Component({
  selector: 'mandates-approve-mandates-banner',
  templateUrl: './approve-mandates-banner.component.html',
  styleUrls: ['./approve-mandates-banner.component.scss']
})
export class ApproveMandatesBannerComponent implements OnInit, OnDestroy {

  protected active: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private stagingMandateStateService: StagingMandateStateService,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.stagingMandateStateService.hasAccess$,
      this.stagingMandateStateService.hasUnapproved$,
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([hasAccess, hasUnapproved]) => {
        this.active = hasAccess && hasUnapproved;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
